module.exports = __webpack_public_path__ + "img/games_title.51c2e037.png";